import React from 'react';
import { Box } from '@mui/material';
import { MenuItemConfig } from './CustomSubList';
import { routes, externalLinks } from '../../../constants';
import { PersonalDetailsSection } from '../../../routes/PersonalDetailsPage/PersonalDetailsPage';
import MeineInhalteSideNavbarHint from '../../redesignOnboardingTour/MeineInhalteSideNavbarHint';
import ImageGeneratorSideNavbarHint from '../../redesignOnboardingTour/ImageGeneratorSideNavbarHint';

interface MenuConfigParams {
  feedbackUrl: string;
}

export const getAdminMenuItems = (): MenuItemConfig[] => [
  { icon: 'clipboardText', label: 'Dashboard', to: routes.schoolAdmin.root },
  { icon: 'productTab', label: 'Teachers', to: routes.schoolAdminTeachers.root },
  { icon: 'calendar', label: 'License & Billing', to: routes.schoolAdminLicence.root },
  { icon: 'user', label: 'Admins', to: routes.schoolAdminList.root },
];

export const getLibraryMenuItems = (): MenuItemConfig[] => [
  { icon: 'searchNormal', label: 'Search', to: routes.search.root },
  {
    icon: 'save',
    label: 'Saved',
    to: routes.collections.root,
    activePaths: [routes.collections.root, routes.followed.root, routes.pinned.root],
  },
  {
    icon: 'downloads',
    label: 'Downloads',
    to: routes.downloads.root,
  },
];

export const getSupportMenuItems = ({ feedbackUrl }: MenuConfigParams): MenuItemConfig[] => [
  { icon: 'message', label: 'Feedback', to: feedbackUrl, external: true },
  { icon: 'messageQuestion', label: 'Help', to: externalLinks.faq, external: true },
];

export const getSettingsMenuItems = (): MenuItemConfig[] => [
  {
    icon: 'profileCircle',
    label: 'My Profile',
    to: `${routes.personalDetails.root}/${PersonalDetailsSection.PROFILE}`,
  },
  {
    icon: 'cards',
    label: 'My Account',
    to: `${routes.personalDetails.root}/${PersonalDetailsSection.ACCOUNT}`,
  },
];

export const getMukibudeMenuItems = (
  onAIToolsClick?: () => void,
): MenuItemConfig[] => [
  {
    icon: 'aiTools',
    label: 'AI Tools',
    to: routes.aiTools.root,
    onClick: onAIToolsClick,
    renderWrapper: (children) =>
      <ImageGeneratorSideNavbarHint><Box>{children}</Box></ImageGeneratorSideNavbarHint>,
  },
  {
    icon: 'myContent',
    label: 'My Contents',
    to: routes.myContents.root,
    renderWrapper: (children) =>
      <MeineInhalteSideNavbarHint><Box>{children}</Box></MeineInhalteSideNavbarHint>,
  },
  {
    icon: 'recent',
    label: 'Course',
    to: routes.aiAssistantHistory.root,
  },
];

interface CourseMenuParams {
  isSchulenUser?: boolean;
}

export const getCourseMenuItems = (
  { isSchulenUser = false }: CourseMenuParams = {}): MenuItemConfig[] => {
  // SCORM Cloud (US-hosted) is disabled for schulen users for GDPR compliance,
  // so the entire course section is hidden for them (SCHOOL-497).
  if (isSchulenUser) {
    return [];
  }

  return [
    {
      icon: 'teacherNav',
      label: 'Course Catalog',
      to: routes.courseCatalog.root,
    },
    {
      icon: 'folderFavourite',
      label: 'My Courses',
      to: routes.myCourses.root,
    },
    {
      icon: 'medal',
      label: 'Certificate',
      to: routes.myCertificates.root,
    },
  ];
};
